// 详情内容
import V2DetailItem from '@/common/components/Feedback/V2DetailItem';
import V2DetailGroup from '@/common/components/Feedback/V2DetailItem/Group';
import V2Title from '@/common/components/Feedback/V2Title';
import { Col, Row } from 'antd';
import { FC, useContext, useEffect, useRef, useState } from 'react';
import DetailOperate from './DetailOperate';
import { isArray, isNotEmptyAny } from '@lhb/func';
import { editDefaultValue, imagePropertyNames } from '../../shopEdit/ts-config';
import { useMethods } from '@lhb/hook';
import DetailRecord from './DetailRecord/index';
import { globalExpansionTaskAlias, globalFranchiseeAlias } from '@/common/utils/ways';
import UserInfoContext from '@/layout/context';
import FranchiseeDetailDrawer from '@/common/components/business/ExpandStore/FranchiseeDetailDrawer';
// import { ShopDetailAdditionalItems } from '../ts-config';

interface DetailMainProps {
  detail: any;
  isApproval?: boolean;
  onClose?: any;
  reload?: any
}

const DetailMain: FC<DetailMainProps> = ({ detail, isApproval = false, reload }) => {
  const detailRecordRef: any = useRef();
  const [configs, setConfigs] = useState<any>([]);
  const RNET_MODE_NAME_BROKERRAGE = 2; // 租金模式-扣点
  const RNET_MODE_NAME_RARISE = 3; // 租金模式-取高
  const [detailData, setDetailData] = useState<any>({
    open: false,
  }); // 加盟商详情数据
  const { tenantInfo: { globalAliasItemVOs } } = useContext(UserInfoContext); // 租户信息
  const franchiseeAlias = globalFranchiseeAlias(globalAliasItemVOs);
  const expansionTaskAlias = globalExpansionTaskAlias(globalAliasItemVOs);

  useEffect(() => {
    if (!detail?.configs && !isArray(detail?.configs)) return;
    /**
     * 过滤列表不显示的信息
     */
    const result = detail?.configs?.filter(item => item.checked)?.map(item => {
      item.config = editDefaultValue[item.field];
      return item;
    }) || [];

    // const allFields = [...result, ...ShopDetailAdditionalItems];

    methods.setHiddenField(result, detail.rentMode);
    setConfigs(result?.filter(item => !item.hidden));

  }, [detail?.configs]);

  const methods = useMethods({
    reload() {
      detailRecordRef.current?.init();
      reload?.();
    },
    /**
     * 设置隐藏字段
     * @param fields 显示fileds
     * @param currentValue 当前选中值，
     */
    setHiddenField(fields, currentValue = '') {
      if (!isNotEmptyAny(fields)) return;
      const firstYearMonthRentField = fields.find(item => item.field === 'firstYearMonthRent');
      const secondYearMonthRentField = fields.find(item => item.field === 'secondYearMonthRent');
      const thirdYearMonthRentField = fields.find(item => item.field === 'thirdYearMonthRent');
      const brokerageField = fields.find(item => item.field === 'brokerage');

      if (+currentValue === RNET_MODE_NAME_BROKERRAGE) { // 扣点模式
        firstYearMonthRentField && (firstYearMonthRentField.hidden = true);
        secondYearMonthRentField && (secondYearMonthRentField.hidden = true);
        thirdYearMonthRentField && (thirdYearMonthRentField.hidden = true);
        brokerageField && (brokerageField.hidden = false);
      } else if (+currentValue === RNET_MODE_NAME_RARISE) { // 租金模式-取高模式
        firstYearMonthRentField && (firstYearMonthRentField.hidden = false);
        secondYearMonthRentField && (secondYearMonthRentField.hidden = false);
        thirdYearMonthRentField && (thirdYearMonthRentField.hidden = false);
        brokerageField && (brokerageField.hidden = false);
      } else if (!currentValue) { // 如果没有设置值
        firstYearMonthRentField && (firstYearMonthRentField.hidden = true);
        secondYearMonthRentField && (secondYearMonthRentField.hidden = true);
        thirdYearMonthRentField && (thirdYearMonthRentField.hidden = true);
        brokerageField && (brokerageField.hidden = true);
      } else { // 其他模式
        firstYearMonthRentField && (firstYearMonthRentField.hidden = false);
        secondYearMonthRentField && (secondYearMonthRentField.hidden = false);
        thirdYearMonthRentField && (thirdYearMonthRentField.hidden = false);
        brokerageField && (brokerageField.hidden = true);
      }


      setConfigs(fields);
    },

    /**
     * 获取筛选项的值
     * @param val
     * @returns
     */
    getDetailItemValue(val: any) {
      if (val.controlType === 'area') {
        return detail[val.code];
      } else if (val.code === 'franchiseeName') {
        return detail[val.code];
      } else if (val.controlType === 'dropDownRadio') {
        const result = val.selectionList.find(item => item.value === detail[val.field]);
        return result ? result['name'] : (detail[val.code] || ''); // 有值但是该选项已被删除时，展示以前设置选项的名称（门店类型选项被停用的情况）
      } else if (val.controlType === 'fileUpload') {
        return [];
      }
      return detail[val.field];
    },
    getItemsType(code) {
      return {
        'franchiseeName': 'link',
      }[code] || 'text';
    },
    /**
   * @description 点击名称查看拓店任务详情
   */
    franchiseeName() {
      detail?.franchiseeId && setDetailData({
        open: true,
        id: detail.franchiseeId,
      });
    }
  });

  return (
    <>
      {!isApproval && <DetailOperate detail={detail} reload={methods.reload} />}

      <V2Title type='H2' text='基本信息' divider/>
      <V2DetailGroup block>
        <Row gutter={16}>
          {configs?.map(item => {
            return (<Col span={8} key={item.code}>
              {item.controlType === 'fileUpload'
                ? <V2DetailItem label={item.name} type={imagePropertyNames.includes(item.code) ? 'images' : 'files'} assets={detail[item.field]} />
                : <V2DetailItem
                  label={item.name}
                  type={methods.getItemsType(item.code)}
                  onClick={ methods.getItemsType(item.code) === 'link' && methods[item.code]}
                  value={methods.getDetailItemValue(item)} />
              }
            </Col>);
          })}
        </Row>
      </V2DetailGroup>

      {/* 拓店日志 */}
      {(isNotEmptyAny(detail) && !isApproval) && <DetailRecord detail={detail} reload={reload} ref={detailRecordRef} expansionTaskAlias={expansionTaskAlias} />}
      {/* 加盟商详情 */}
      <FranchiseeDetailDrawer
        detailData={detailData}
        setDetailData={setDetailData}
        onSearch={reload}
        franchiseeAlias={franchiseeAlias}
      />
    </>
  );
};

export default DetailMain;
